import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=5960c343&"
import script from "./FiltersComponent.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltersComponent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports